/* ==========================================================================
   Helium Deco V3 — Reversible Scroll-linked Animations
   - Featured/Showcase/Designer: IntersectionObserver for robust enter/leave
   - About Us: continuous scroll-progress (panel + clip-path + zoom)
   ========================================================================== */

/* --- Mobile Menu Toggle ---------------------------------------------------
   Event-delegated on `document` and registered at script load (not inside
   DOMContentLoaded) so it works on EVERY template — not just the homepage —
   and survives any header re-render by apps/filters. The previous version
   bound the click handler to a specific node captured at load, which silently
   failed on collection/product pages. */
(function initMobileMenu() {
    const closeMenu = () => {
        const overlay = document.querySelector('.mobile-nav-overlay');
        const toggle = document.querySelector('.mobile-menu-toggle');
        if (overlay) overlay.classList.remove('is-visible');
        if (toggle) toggle.classList.remove('is-open');
        document.body.style.overflow = '';
    };

    document.addEventListener('click', (e) => {
        const toggle = e.target.closest('.mobile-menu-toggle');
        if (toggle) {
            const overlay = document.querySelector('.mobile-nav-overlay');
            if (!overlay) return;
            const willOpen = !overlay.classList.contains('is-visible');
            toggle.classList.toggle('is-open', willOpen);
            overlay.classList.toggle('is-visible', willOpen);
            document.body.style.overflow = willOpen ? 'hidden' : '';
            return;
        }
        // Tapping any link inside the drawer closes it before navigating.
        if (e.target.closest('.mobile-nav-overlay a')) closeMenu();
    });

    // Esc closes the drawer.
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });
})();

document.addEventListener('DOMContentLoaded', () => {


    /* --- Quote Modal --- */
    const modal = document.getElementById('quoteModal');
    const form = document.getElementById('quoteForm');
    const success = document.getElementById('quoteSuccess');

    if (modal) {
        const closeBtn = modal.querySelector('.quote-modal__close');
        const backdrop = modal.querySelector('.quote-modal__backdrop');

        function openModal(e) {
            if (e) e.preventDefault();
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            if (form) form.style.display = '';
            if (success) success.style.display = 'none';
        }

        function closeModal() {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
        }

        document.querySelectorAll('a[href="#quote"]').forEach(t => t.addEventListener('click', openModal));
        closeBtn?.addEventListener('click', closeModal);
        backdrop?.addEventListener('click', closeModal);
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });

        form?.addEventListener('submit', (e) => {
            e.preventDefault();
            form.style.display = 'none';
            if (success) success.style.display = 'block';
        });
    }


    /* =====================================================================
       Hero Slider — Whole-banner crossfade
       Reads slide payload from a JSON island the section liquid renders.
       Each slide carries its own EXPLORE deep link to the featured
       collection — that link is also swapped on transition.
       ===================================================================== */
    const heroSlidesEl = document.querySelector('[data-hero-slides]');
    let slides = [];
    if (heroSlidesEl) {
        try { slides = JSON.parse(heroSlidesEl.textContent); }
        catch (_) { slides = []; }
    }

    const heroInner    = document.querySelector('.hero__inner');
    const heroHeading  = document.querySelector('.hero__heading');
    const cardImg      = document.querySelector('.hero__card-img__el');
    const mainImg      = document.querySelector('.hero__main-img__el');
    const cardNameEl   = document.querySelector('.hero__card-name');
    const cardTypeEl   = document.querySelector('.hero__card-type');
    const counterEl    = document.querySelector('.hero__counter-current');
    const totalEl      = document.querySelector('.hero__counter-total');
    const nextBtn      = document.querySelector('.hero__nav-btn--next');
    const prevBtn      = document.querySelector('.hero__nav-btn--prev');
    const exploreBtn   = document.querySelector('[data-hero-explore]');
    const exploreLabel = document.querySelector('[data-hero-explore-text]');

    if (heroInner && heroHeading && cardImg && mainImg && nextBtn && prevBtn && slides.length) {
        let currentIndex = 0;
        let isAnimating = false;

        if (totalEl) totalEl.textContent = String(slides.length).padStart(2, '0');
        if (counterEl) counterEl.textContent = '01';

        // Cross-fade the background photo between two stacked layers so it
        // never flashes to black between slides. The incoming layer gets the
        // new src at opacity 0, is raised above the current layer, then fades
        // to 1 once decoded — the outgoing photo stays underneath the whole time.
        const imgLayers = Array.prototype.slice.call(document.querySelectorAll('.hero__main-img__el'));
        let activeImg = 0;
        let imgZ = 1;
        function setHeroImage(src, alt, focal) {
            if (!src) return;
            if (imgLayers.length < 2) {
                if (mainImg) { mainImg.src = src; mainImg.alt = alt || ''; if (focal) mainImg.style.objectPosition = focal; }
                return;
            }
            const incoming = imgLayers[activeImg === 0 ? 1 : 0];
            incoming.style.transition = 'none';
            incoming.style.opacity = '0';
            incoming.src = src;
            incoming.alt = alt || '';
            incoming.style.objectPosition = focal || '50% 50%';
            imgZ += 1;
            incoming.style.zIndex = String(imgZ);
            void incoming.offsetWidth; // commit opacity:0 + new src before fading in
            // Fade in on the next frames (images are preloaded, so they're
            // already decoded — no need to await decode(), which can hang).
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    incoming.style.transition = '';
                    incoming.style.opacity = '1';
                });
            });
            activeImg = activeImg === 0 ? 1 : 0;
        }

        function applySlide(slide, index) {
            if (slide.heading) heroHeading.innerHTML = slide.heading;
            if (slide.card) {
                cardImg.src = slide.card;
                cardImg.alt = (slide.name || '') + ' ' + (slide.type || '');
            }
            if (cardNameEl) cardNameEl.textContent = slide.name || '';
            if (cardTypeEl) cardTypeEl.textContent = slide.type || '';
            if (counterEl)  counterEl.textContent  = String(index + 1).padStart(2, '0');

            // EXPLORE → featured collection deep link, per slide.
            if (exploreBtn && slide.link) exploreBtn.setAttribute('href', slide.link);
            if (exploreLabel && slide.linkText) exploreLabel.textContent = slide.linkText;
        }

        // Preload every slide's images up front so each slide-in is instant.
        slides.forEach(s => {
            if (s.main) { const i = new Image(); i.src = s.main; }
            if (s.card) { const i = new Image(); i.src = s.card; }
        });

        function transition(direction) {
            if (isAnimating) return;
            isAnimating = true;

            const nextIndex = (currentIndex + direction + slides.length) % slides.length;
            const nextSlide = slides[nextIndex];
            const dir = direction > 0 ? 'next' : 'prev';

            // Background photo responds immediately — the cross-fade starts on
            // input rather than waiting for the heading to slide out. This is
            // what removes the perceived latency.
            setHeroImage(nextSlide.main, nextSlide.mainAlt, nextSlide.focal);

            // Heading + product card slide out, swap text, slide back in.
            heroInner.classList.add('hero-exit-' + dir);
            setTimeout(() => {
                applySlide(nextSlide, nextIndex);
                currentIndex = nextIndex;
                heroInner.classList.remove('hero-exit-' + dir);
                heroInner.classList.add('hero-enter-' + dir);
                void heroInner.offsetWidth; // paint the start state before sliding in
                requestAnimationFrame(() => {
                    heroInner.classList.remove('hero-enter-' + dir);
                    setTimeout(() => { isAnimating = false; }, 300);
                });
            }, 190);
        }

        nextBtn.addEventListener('click', () => { transition(1);  restartAuto(); });
        prevBtn.addEventListener('click', () => { transition(-1); restartAuto(); });

        // Swipe support (touch) — swipe left → next, right → previous.
        let swipeX = 0, swipeY = 0, swiping = false;
        heroInner.addEventListener('touchstart', (e) => {
            if (e.touches.length !== 1) { swiping = false; return; }
            swipeX = e.touches[0].clientX;
            swipeY = e.touches[0].clientY;
            swiping = true;
        }, { passive: true });
        heroInner.addEventListener('touchend', (e) => {
            if (!swiping) return;
            swiping = false;
            const t = e.changedTouches[0];
            const dx = t.clientX - swipeX;
            const dy = t.clientY - swipeY;
            // Horizontal swipe must clear a threshold and dominate vertical
            // movement so it doesn't hijack normal page scrolling.
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
                transition(dx < 0 ? 1 : -1);
                restartAuto();
            }
        }, { passive: true });

        // Gentle auto-advance — pauses on hover, respects reduced motion.
        let autoTimer = null;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function startAuto() {
            if (reduceMotion || slides.length < 2 || autoTimer) return;
            autoTimer = setInterval(() => transition(1), 6000);
        }
        function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
        function restartAuto() { stopAuto(); startAuto(); }
        startAuto();
        const heroSection = document.querySelector('.hero');
        if (heroSection) {
            heroSection.addEventListener('mouseenter', stopAuto);
            heroSection.addEventListener('mouseleave', startAuto);
        }
    }


    /* =====================================================================
       UTILITIES
       ===================================================================== */

    let ticking = false;

    function scrollProgress(el) {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const start = vh;
        const end = vh * 0.25;
        return Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
    }

    function lerp(a, b, t) { return a + (b - a) * t; }


    /* =====================================================================
       FEATURED PRODUCTS — IntersectionObserver + staggered fade
       Each row's trigger element is observed. On intersect → stagger in.
       On leave → cancel timers + remove .visible.
       ===================================================================== */

    const featuredRows = [
        { images: ['.fp-1', '.fp-2', '.fp-3', '.fp-4'] },
        { images: ['.fp-5', '.fp-6', '.fp-7', '.fp-8'] },
        { images: ['.fp-9', '.fp-10', '.fp-11', '.fp-12'] },
        { images: ['.fp-13', '.fp-14', '.fp-15', '.fp-16'] },
    ];

    const STAGGER = 300;

    featuredRows.forEach(row => {
        row.els = row.images.map(s => document.querySelector(s));
        row.triggerEl = row.els[0];
        row.timers = [];
    });

    const featuredHeading = document.querySelector('.featured__heading');
    if (featuredHeading) {
        featuredHeading.style.opacity = '0';
        featuredHeading.style.transition = 'opacity 0.8s ease';
    }

    // Observer for the heading
    if (featuredHeading) {
        const headingObs = new IntersectionObserver((entries) => {
            entries.forEach(e => {
                featuredHeading.style.opacity = e.isIntersecting ? '1' : '0';
            });
        }, { rootMargin: '-60px 0px' });
        headingObs.observe(featuredHeading);
    }

    // Observer for each featured row
    const rowObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const row = featuredRows.find(r => r.triggerEl === entry.target);
            if (!row) return;

            if (entry.isIntersecting) {
                // Entering: staggered fade-in
                row.els.forEach((img, i) => {
                    if (!img) return;
                    const t = setTimeout(() => img.classList.add('visible'), i * STAGGER);
                    row.timers.push(t);
                });
            } else {
                // Leaving: cancel pending, remove visible
                row.timers.forEach(clearTimeout);
                row.timers = [];
                row.els.forEach(img => img?.classList.remove('visible'));
            }
        });
    }, { rootMargin: '-60px 0px' });

    featuredRows.forEach(row => {
        if (row.triggerEl) rowObserver.observe(row.triggerEl);
    });


    /* =====================================================================
       ABOUT US — Continuous scroll-progress animation
       Fully reversible — driven by scroll position every frame.
       ===================================================================== */

    const aboutSection = document.querySelector('.about');

    // Slide-in entrance: panel eases in from the left + feature tiles fade
    // up in a stagger when the section scrolls into view. The .about--anim
    // class sets the hidden start state via JS so no-JS users still see it.
    if (aboutSection) {
        aboutSection.classList.add('about--anim');
        const aboutObs = new IntersectionObserver((entries, obs) => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    aboutSection.classList.add('is-visible');
                    obs.unobserve(aboutSection);
                }
            });
        }, { threshold: 0.2 });
        aboutObs.observe(aboutSection);
    }

    // Retained as a no-op for any scroll-loop callers.
    function updateAbout() {}


    /* =====================================================================
       SHOWCASE CAROUSEL — Horizontal scroll with arrow nav
       ===================================================================== */

    const showcaseTrack = document.querySelector('.showcase__track');
    const showcaseCards = document.querySelectorAll('.showcase__card');
    const scPrev = document.querySelector('.showcase .showcase__nav-btn--prev');
    const scNext = document.querySelector('.showcase .showcase__nav-btn--next');

    // Card width + gap for scroll distance
    const CARD_SCROLL = 380 + 24; // card width + gap

    // Detect which card is closest to center and activate it
    function updateActiveCard() {
        if (!showcaseTrack || !showcaseCards.length) return;
        const trackRect = showcaseTrack.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;

        let closestIdx = 0;
        let closestDist = Infinity;

        showcaseCards.forEach((card, i) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const dist = Math.abs(cardCenter - trackCenter);
            if (dist < closestDist) {
                closestDist = dist;
                closestIdx = i;
            }
        });

        showcaseCards.forEach((card, i) => {
            card.classList.toggle('is-active', i === closestIdx);
        });
    }

    if (showcaseTrack) {
        showcaseTrack.addEventListener('scroll', updateActiveCard, { passive: true });
        // Start the carousel centered on the middle of the finish set
        // (after layout so scrollWidth is known).
        requestAnimationFrame(() => {
            const prev = showcaseTrack.style.scrollBehavior;
            showcaseTrack.style.scrollBehavior = 'auto';
            showcaseTrack.scrollLeft = (showcaseTrack.scrollWidth - showcaseTrack.clientWidth) / 2;
            showcaseTrack.style.scrollBehavior = prev || '';
            updateActiveCard();
        });
    }

    if (scPrev && showcaseTrack) {
        scPrev.addEventListener('click', () => {
            showcaseTrack.scrollBy({ left: -CARD_SCROLL, behavior: 'smooth' });
        });
    }

    if (scNext && showcaseTrack) {
        scNext.addEventListener('click', () => {
            showcaseTrack.scrollBy({ left: CARD_SCROLL, behavior: 'smooth' });
        });
    }


    /* =====================================================================
       DESIGNER — IntersectionObserver + progressive reveal
       ===================================================================== */

    const designerSection = document.querySelector('.designer');
    const designerImg = document.querySelector('.designer__image img');
    const designerHeading = document.querySelector('.designer__heading');
    const designerParagraphs = document.querySelectorAll('.designer__body p');
    let designerTimers = [];

    if (designerSection) {
        const designerObs = new IntersectionObserver((entries) => {
            entries.forEach(e => {
                if (e.isIntersecting) {
                    let delay = 0;
                    const PHASE = 400, PARA = 250;

                    designerTimers.push(setTimeout(() => designerImg?.classList.add('visible'), delay));
                    delay += PHASE;
                    designerTimers.push(setTimeout(() => designerHeading?.classList.add('visible'), delay));
                    delay += PHASE;

                    designerParagraphs.forEach((p, i) => {
                        designerTimers.push(setTimeout(() => p.classList.add('half-visible'), delay + i * PARA * 2));
                        designerTimers.push(setTimeout(() => {
                            p.classList.remove('half-visible');
                            p.classList.add('visible');
                        }, delay + i * PARA * 2 + PARA));
                    });
                } else {
                    designerTimers.forEach(clearTimeout);
                    designerTimers = [];
                    designerImg?.classList.remove('visible');
                    designerHeading?.classList.remove('visible');
                    designerParagraphs.forEach(p => {
                        p.classList.remove('half-visible', 'visible');
                    });
                }
            });
        }, { rootMargin: '-60px 0px' });
        designerObs.observe(designerSection);
    }


    /* =====================================================================
       SCROLL HANDLER — only About Us needs per-frame updates
       ===================================================================== */

    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(() => {
                updateAbout();
                ticking = false;
            });
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();


    /* =====================================================================
       SMOOTH SCROLL for anchor links
       ===================================================================== */

    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
            const target = document.querySelector(link.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });

});
